import actionTypes from './actionTypes';

export const retrieveInventoryFilterCategoryTreeNode = data => ({
  type: actionTypes.REQUEST_INVENTORY_FILTER_CATEGORY_TREE_NODE,
  data,
});

export const getInventoryFilterCategoryTreeNodeSuccess = data => ({
  type: actionTypes.GET_INVENTORY_FILTER_CATEGORY_TREE_NODE_SUCCESS,
  data,
});

export const getInventoryFilterCategoryTreeNodeFailure = () => ({
  type: actionTypes.GET_INVENTORY_FILTER_CATEGORY_TREE_NODE_FAILURE,
});

export const clearInventoryFilterCategoryTreeNode = () => ({
  type: actionTypes.CLEAR_INVENTORY_FILTER_CATEGORY_TREE_NODE,
});

export const clearInventoryFilterCategoryTreeNodeSuccess = () => ({
  type: actionTypes.CLEAR_INVENTORY_FILTER_CATEGORY_TREE_NODE_SUCCESS,
});

export const clearInventoryFilterCategoryTreeNodeFailure = () => ({
  type: actionTypes.CLEAR_INVENTORY_FILTER_CATEGORY_TREE_NODE_FAILURE,
});

export const retrieveInventoryCategories = data => ({
  type: actionTypes.REQUEST_INVENTORY_CATEGORIES,
  data,
});

export const getInventoryCategoriesSuccess = data => ({
  type: actionTypes.GET_INVENTORY_CATEGORIES_SUCCESS,
  data,
});

export const getInventoryCategoriesFailure = () => ({
  type: actionTypes.GET_INVENTORY_CATEGORIES_FAILURE,
});

export const requestCreateCategory = data => ({
  type: actionTypes.REQUEST_CREATE_CATEGORY,
  data,
});

export const createCategorySuccess = data => ({
  type: actionTypes.CREATE_CATEGORY_SUCCESS,
  data,
});

export const createCategoryFailure = () => ({
  type: actionTypes.CREATE_CATEGORY_FAILURE,
});

export const requestCategoryTreeUpdate = data => ({
  type: actionTypes.REQUEST_CATEGORY_TREE_UPDATE,
  data,
});

export const updateCategoryTreeSuccess = data => ({
  type: actionTypes.UPDATE_CATEGORY_TREE_SUCCESS,
  data,
});

export const updateCategoryTreeFailure = () => ({
  type: actionTypes.UPDATE_CATEGORY_TREE_FAILURE,
});

export const requestFullCategoryTree = () => ({
  type: actionTypes.REQUEST_FULL_CATEGORY_TREE,
});

export const getFullCategoryTreeSuccess = data => ({
  type: actionTypes.GET_FULL_CATEGORY_TREE_SUCCESS,
  data,
});

export const getFullCategoryTreeFailure = () => ({
  type: actionTypes.GET_FULL_CATEGORY_TREE_FAILURE,
});
